import React, { useState,useEffect } from "react";
import { toast } from 'react-toastify';
import Loader from './Loader';
import ApiService from '../services/ApiService';
import { Modal, Button } from 'react-bootstrap';

import sampleFile from '../assets/files/Upload-Questions-Sample.xlsx'; 

function UploadQuestion({ updateQuestions, closeModal , test_id }) {

  const [isLoader, setIsLoader] = useState(false);
  const [file, setFile] = useState(null);


  const handleFileChange = (e) => {
    const file = e.target.files[0];
    // console.log(file);
    setFile(file);
  };

  const submitForm = async (e) => {
    e.preventDefault(); // Prevent default form submission
    setIsLoader(true);
    try {
      const data = new FormData();
      data.append('test_id', test_id);
      data.append('file', file);

      const response = await ApiService.request({
        method: 'POST',
        url: 'upload-questions/', // Replace with your API endpoint
        data: data
      });

      if (response.data.status) {
        toast.success(response.data.message);
        closeModal();
        updateQuestions();
      } else {
        toast.error(response.data.message);
      }
      setIsLoader(false);
    } catch (error) {
      console.error('Form submission failed:', error);
      setIsLoader(false);
    }
  };


  return (
    <div>
      <div className="backdrop"></div>
      {/* Modal for Question */}
      <div
        className="modal fade show"
        id="exampleModalLive"
        tabIndex="-1"
        aria-labelledby="exampleModalLiveLabel"
        aria-modal="true"
        role="dialog"
        style={{ display: 'block' }}
      >
        <div className="modal-dialog modal-lg modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header">
              <h4>Upload Questions</h4>
          
            </div>

            <form onSubmit={submitForm}>
              <div className="modal-body modal-lg">
                <h6 className="text-center">Select a CSV File <a href={sampleFile}>Download Sample</a></h6>
                <div className="row">
               
                    <div className="col-md-12 fv-row fv-plugins-icon-container">
                      <label className="fs-6 fw-semibold mb-2 required"> File </label>
                      <input type="file" className="form-control" onChange={handleFileChange} />
                    </div>

                </div>

              </div>
              <div className="modal-footer">
                <Button
                  type="button"
                  onClick={closeModal}
                  className="btn btn-secondary me-3"
                >
                  Close
                </Button>
                <Button type="submit" className="btn btn-base me-3" disabled={isLoader}>
                   <span  hidden={isLoader}> Upload  </span>
                    {isLoader && <Loader size="30" text="Uploading" color="white" />}
                </Button>
              </div>
            </form>
          </div>
        </div>
      </div>
    </div>
  );
}

export default UploadQuestion;
